import { useMemo } from 'react';
import { StoreSaleNftModel } from '~/components/Nft';
import { OpenDay } from '~/components/Timer/OpenDay/OpenDay';
import { Timer } from '~/components/Timer/Timer';

export type SaleTimerProps = Pick<StoreSaleNftModel, 'saleStatus' | 'openAt' | 'closeAt'> & {
  className?: string;
};

export const SaleTimer = ({ saleStatus, openAt, closeAt, className }: SaleTimerProps) =>
  useMemo(() => {
    switch (saleStatus) {
      case 'UPCOMING':
        return <OpenDay openAt={openAt} className={className} />;
      case 'FOR_SALE':
        return <Timer className={className} value={closeAt} />;
      default:
        return null;
    }
  }, [className, closeAt, openAt, saleStatus]);
